export const url = 'https://nets.tj/api/'

// export const url = 'http://10.251.4.191:8603/api/'